import React from 'react'
import { useStoryMode } from '../../contexts/StoryModeContext'
import Modal from '../../Modal'
import './StoryLevelPicker.css'

const StoryLevelPicker = ({ onClose, onSelectLevel }) => {
  const { getAllLevelsStatus, currentLevelIndex } = useStoryMode()
  const levels = getAllLevelsStatus()

  const handleLevelClick = (level) => {
    if (level.unlocked) {
      onSelectLevel(level.index)
      onClose()
    }
  }

  return (
    <Modal onClose={onClose}>
      <div className="story-level-picker">
        <h2>Select Level</h2>
        <div className="level-grid">
          {levels.map((level) => (
            <button
              key={level.index}
              className={`level-btn ${
                level.completed ? 'completed' : ''
              } ${level.index === currentLevelIndex ? 'current' : ''} ${
                !level.unlocked ? 'locked' : ''
              }`}
              onClick={() => handleLevelClick(level)}
              disabled={!level.unlocked}
            >
              <span className="level-number">{level.index}</span>
              {level.completed && <span className="check-icon">✓</span>}
              {!level.unlocked && <span className="lock-icon">🔒</span>}
            </button>
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default StoryLevelPicker
